/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 10:55:58
 * @LastEditTime: 2020-09-16 15:23:04
 * @Description: 公司api
 */
import axios from '@/utils/axios'

export const getCompanyList = (payload) => {
    return axios.get('/company', {
        params: payload
    })
}

export const getCompanyByID = (id) => {
    return axios.get(`/company/${id}`)
}

export const updateCompany = (id, data) => {
    return axios.put(`/company/${id}`, data)
}

export const createCompany = (data) => {
    return axios.post(`/company`, data)
}

export const deleteCompany = (id) => {
    return axios.delete(`/company/${id}`)
}